import React, { useEffect, useRef, useState } from "react";
import { uploadFiles, generateSinglePreSignedUrl, startMultipartUpload, generatePresignedUrl, completeMultipartUpload, saveFiles, validateFile } from "../api";
import HeaderSection from "../child_components/HeaderSection";
import { toast } from "react-toastify";
import { COUNTRIES, MANUFACTURER, YEAR, REVISION } from "../lib/countries";
import { btnOne, inputStyle, label } from "../utils/style";
import fetchData from "../custom_functions/fetchData";
import { url } from "../utils/config";
import { dateValidator } from "../custom_functions/dateValidator";
import Select from "../reusable_components/Select";
import Input from "../reusable_components/Input";
import MultiSelectDropdown from "../reusable_components/MultiSelectDropdown";
import axios from "axios";

const DirectoryUpload = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);
  const [formInput, setFormInput] = useState({ 'manufacturer': "", 'model': "", 'year': "", 'revision': "", 'region': "", 'publication_date': "", 'software_version': "" });
  const [cars, setCars] = useState([])
  const [missingFields, setMissingFields] = useState([]);
  const [inputErrors, setInputErrors] = useState([]);
  const [showInputError, setShowInputError] = useState(false);

  const requiredFields = ['manufacturer', 'model', 'year', 'revision', 'region', "publication_date"]

  useEffect(() => { fetchCars() }, [])

  function getMakeList() {
    const make = [];
    cars.forEach(car => {
      if (!make.includes(car.make)) {
        make.push(car.make)
      }
    })
    make.sort()
    return make;
  }

  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    const pdfFiles = files.filter((file) => file.type === "application/pdf");
    if (selectedFiles.length + pdfFiles.length > 5) {
      toast.error("You can upload a maximum of 5 files.", { autoClose: 3000 });
    } else {
      setSelectedFiles((prevFiles) => [...prevFiles, ...pdfFiles]);
    }
  };

  async function fetchCars() {
    fetchData(`${url}/all_cars`, (error) => {
      toast.error(error.response.data.message, { autoClose: 3000 })
    }, (data) => {
      setCars(data.data)
    })
  }

  const isInvalid = (value) => !value || value === 'select' || value === '';

  const handleUpload = async () => {
    setUploading(true)
    const result = { success: [], fail: [], alreadyExist: [] }
    const indexFiles = []
    try {

      const missed = requiredFields.filter((field) =>
        field === 'publication_date'
          ? isInvalid(formInput[field]) || !dateValidator(formInput[field])
          : isInvalid(formInput[field])
      );

      if (missed.length > 0) {
        setMissingFields(missed)
        setShowInputError(true)
        return
      }

      for (let index = 0; index < selectedFiles.length; index++) {
        const file = selectedFiles[index];
        const updatedName = `${formInput.manufacturer}_${formInput.model}_${formInput.year}_${formInput.revision}_${formInput.region}_${file.name}`;
        const isExistFile = await validateFile({ fileName: updatedName, manufacturer: formInput.manufacturer, model: formInput.model, revision: formInput.revision, region: formInput.region, year: formInput.year })

        if (isExistFile?.data?.status === true) {
          result.alreadyExist.push(file.name);
          continue;
        }

        if (file.size < 10000000) {
          // Call your API to get the presigned URL
          const response = await generateSinglePreSignedUrl({ fileName: updatedName })

          const { url } = response.data;
          // Use the presigned URL to upload the file
          const uploadResponse = await axios.put(url, file, {
            headers: {
              "Content-Type": file.type,
            },
          });

          if (uploadResponse.status === 200) {
            result.success.push(file.name)
            indexFiles.push({ file_name: updatedName, file_size: file.size })
          } else {
            result.fail.push(file.name)
          }

        } else {
          // call multipart upload endpoint and get uploadId
          const response = await startMultipartUpload({ fileName: updatedName, contentType: file.type });

          // get uploadId
          let { uploadId } = response.data;

          // get total size of the file
          let totalSize = file.size;
          // set chunk size to 7MB
          let chunkSize = 7000000;
          // calculate number of chunks
          let numChunks = Math.ceil(totalSize / chunkSize);

          // generate presigned urls
          let presignedUrls_response = await generatePresignedUrl({ fileName: updatedName, uploadId: uploadId, partNumbers: numChunks });

          let presigned_urls = presignedUrls_response?.data?.presignedUrls;

          // upload the file into chunks to different presigned url
          let parts = [];
          const uploadPromises = [];

          for (let i = 0; i < numChunks; i++) {
            let start = i * chunkSize;
            let end = Math.min(start + chunkSize, totalSize);
            let chunk = file.slice(start, end);
            let presignedUrl = presigned_urls[i];

            uploadPromises.push(
              axios.put(presignedUrl, chunk, {
                headers: {
                  "Content-Type": file.type,
                },
              })
            );
          }

          const uploadResponses = await Promise.all(uploadPromises);

          uploadResponses.forEach((response, i) => {
            // existing response handling

            parts.push({
              etag: response.headers.etag,
              PartNumber: i + 1,
            });
          });

          // make a call to multipart complete api
          let complete_upload = await completeMultipartUpload({ fileName: updatedName, uploadId: uploadId, parts: parts });

          // if upload is successful, alert user
          if (complete_upload.status === 200) {
            result.success.push(file.name)
            indexFiles.push({ file_name: updatedName, file_size: file.size })
          } else {
            result.fail.push(file.name)
          }
        }
      }

      if (result.success.length > 0) {
        // console.log("formInput",formInput)
        // console.log("indexFiles",indexFiles)

        saveFiles({ formInput, indexFiles })
        toast.success(`Success: ${result.success.join(", ")}`, { autoClose: 3000 })
      }

      if (result.fail.length > 0) {
        toast.error(`Fail: ${result.fail.join(", ")}`, { autoClose: 3000 })
      }

      if (result.alreadyExist.length > 0) {
        toast.error(`Already Exist: ${result.alreadyExist.join(", ")}`, { autoClose: 3000 })
      }
      setSelectedFiles([])
      setMissingFields([])
      setFormInput({ 'manufacturer': "", 'model': "", 'year': "", 'revision': "", 'region': "", 'publication_date': "", 'software_version': "" });
    } catch (err) {
      console.log(err)
      toast.error("Upload Failed", { autoClose: 3000 });
    } finally {
      setUploading(false);
    }
  };

  const inputEvent = (e) => {
    const { name, value } = e.target;

    if (name === 'publication_date' && value.length > 10) {
      return
    }

    setFormInput((old) => {
      return {
        ...old,
        [name]: value,
      };
    });
  };

  const handleSpanClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const removeFile = (index) => {
    const updatedFiles = [...selectedFiles];
    updatedFiles.splice(index, 1);
    setSelectedFiles(updatedFiles);
  };

  return (
    <>
      <HeaderSection title={"File Upload"} />
      <div className="max-w-screen-lg mx-auto p-6 bg-white rounded-md shadow-lg">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div>
            <label className={label}>
              Manufacturer
            </label>
            <Select
              id="manufacturer"
              name="manufacturer"
              placeHolder={'Manufacturer'}
              // valueKey={'make'}
              // nameKey={'make'}
              required={true}
              index={0}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.manufacturer}
              onChange={inputEvent}
              options={getMakeList()}
            />
          </div>
          <div>
            <label className={label}>
              Model
            </label>
            <Select
              id="model"
              name="model"
              placeHolder={'Model'}
              valueKey={'model'}
              nameKey={'model'}
              required={true}
              index={1}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.model}
              onChange={inputEvent}
              options={[...new Set(cars.filter(car => car.make === formInput.manufacturer).map(car => car.model))].sort().map(model => ({
                model
              }))}

            />
          </div>

          <div>
            <label className={label}>
              Year
            </label>
            <MultiSelectDropdown
              id="year"
              name="year"
              valueKey={'year'}
              nameKey={'year'}
              placeHolder={'Year'}
              required={true}
              index={2}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.year}
              onChange={inputEvent}
              options={cars.filter(car => car.make === formInput.manufacturer && car.model === formInput.model)}
            />
          </div>
          <div>
            <label className={label}>
              Manual Publish Date
            </label>
            <Input
              id="publication_date"
              name="publication_date"
              type="date"
              placeHolder={'Date'}
              required={true}
              index={3}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.publication_date}
              onChange={inputEvent}
            />
          </div>
          <div>
            <label className={label}>
              Revision
            </label>
            <Select
              id="revision"
              name="revision"
              placeHolder={'Revision'}
              required={true}
              index={4}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.revision}
              onChange={inputEvent}
              options={REVISION}
            />
          </div>
          <div>
            <label className={label}>
              Region
            </label>
            <Select
              id="region"
              name="region"
              placeHolder={'Region'}
              required={true}
              index={5}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.region}
              onChange={inputEvent}
              options={COUNTRIES}
            />
          </div>
          <div>
            <label className={label}>
              Software Version
            </label>
            <Input
              id="software_version"
              name="software_version"
              placeHolder={'Version'}
              required={true}
              index={6}
              inputErrors={inputErrors}
              setInputErrors={setInputErrors}
              missingFields={missingFields}
              className={inputStyle}
              value={formInput.software_version}
              onChange={inputEvent}
            />
          </div>
        </div>

        <div className="mt-6 border border-gray-300 rounded-md p-6">
          <div
            className="border-dashed border-2 border-gray-400 rounded-lg p-6 text-center bg-gray-50 hover:bg-gray-100 transition-all"
            onDrop={(event) => {
              event.preventDefault();
              const files = Array.from(event.dataTransfer.files);
              const pdfFiles = files.filter(
                (file) => file.type === "application/pdf"
              );
              setSelectedFiles((prevFiles) => [...prevFiles, ...pdfFiles]);
            }}
            onDragOver={(e) => e.preventDefault()}
          >
            <p className="text-gray-600 text-sm md:text-base">
              Drag and drop your PDF files here or{" "}
              <span
                className="text-blue-600 underline cursor-pointer"
                onClick={handleSpanClick}
              >
                click to upload
              </span>
            </p>
            <input
              type="file"
              name="files"
              accept=".pdf"
              multiple
              onChange={handleFileSelect}
              ref={fileInputRef}
              className="hidden"
            />
          </div>

          {selectedFiles.length > 0 && (
            <div className="mt-4">
              <div className="max-h-40 overflow-y-auto rounded p-2">
                <ul className="space-y-2">
                  {selectedFiles.map((file, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center p-2 hover:bg-gray-50"
                    >
                      <span className="truncate">{file.name}</span>
                      <button
                        className="text-red-500 hover:underline"
                        onClick={() => removeFile(index)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}

          <button
            onClick={handleUpload}
            disabled={uploading || selectedFiles.length === 0}
            className={`mt-4 ${btnOne} ${uploading || selectedFiles.length === 0
              ? "cursor-not-allowed"
              : ""
              } font-semibold`}
          >
            {uploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DirectoryUpload;
